import { format } from 'date-fns';
import type { TFunction } from 'i18next';
import { parseApiScheduleDate } from '@admin/pages/personalization/content-block-workspace-schedule.ts';

const SLIDES_ACTIVE_ONE_KEY = 'admin.contentblock.hub.block.slides.active.one';
const SLIDES_ACTIVE_OTHER_KEY = 'admin.contentblock.hub.block.slides.active.other';

/** Libellé du nombre de slides actives sur un bloc hub. */
export const formatHubActiveSlideCount = (count: number, t: TFunction): string =>
  t(count <= 1 ? SLIDES_ACTIVE_ONE_KEY : SLIDES_ACTIVE_OTHER_KEY, { count });

const formatScheduleDay = (date: Date): string => format(date, 'dd/MM/yyyy');

/** Période d’affichage hub (startAt / endAt API) ; `null` si aucune date. */
export const formatHubBlockScheduleLabel = (
  workspace: { startAt?: string | null; endAt?: string | null },
  t: TFunction
): string | null => {
  const start = parseApiScheduleDate(workspace.startAt);
  const end = parseApiScheduleDate(workspace.endAt);

  if (start && end) {
    return t('admin.contentblock.hub.block.schedule.range', {
      start: formatScheduleDay(start),
      end: formatScheduleDay(end)
    });
  }
  if (start) {
    return t('admin.contentblock.hub.block.schedule.from', { date: formatScheduleDay(start) });
  }
  if (end) {
    return t('admin.contentblock.hub.block.schedule.until', { date: formatScheduleDay(end) });
  }
  return null;
};
